import {
    Typography,
    Box,
    Link,
    createTheme,
    ThemeProvider,
} from "@mui/material";
import baseTheme from "../../../themes/baseTheme";
import React, { useState, useEffect } from "react";
import GetfVDateFormate from "../../../utils/Genaricfunctions";


const { palette } = baseTheme;
const theme = createTheme({});
const padding = "16px 24px";
export default function RecentDocumentsListitem({ status, headers = [], statusRoleMap, ...props }) {
    status = statusRoleMap[status];

    return (
        <>
            <ThemeProvider theme={theme}>
                <Box
                    display="flex"
                    padding={padding}
                    borderBottom="solid 1px"
                    borderColor={palette.grey[30]}
                    alignItems="center"
                >
                    <Box
                     width={headers.find((h) => h.id === "VendorName")}
                     >
                        <a
                            variant="body2"
                            style={{
                                textDecoration: "none",
                                color: "#2A93DB",
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "break-spaces",
                                fontWeight: "500",
                               
                            }}
                            href={"/vendordetails?pqid=" + props?.prequalificationId + "&tab=Questionnaire&sectionid=" + props?.templateSectionID}
                        >
                            {props?.vendorName}
                        </a>
                    </Box>
                    <Box width={headers.find((h) => h.id === "documentTypeName")}>
                        <Typography variant="body2">{props?.documentTypeName}</Typography>
                    </Box>
                    <Box width={headers.find((h) => h.id === "vendorStatus")} >
                        <Typography variant="body2">{props?.vendorStatus}</Typography>
                    </Box>
                    <Box width={headers.find((h) => h.id === "expirationDate")}>
                        <Typography variant="body2"> {props?.expirationDate == "" ? "" : GetfVDateFormate(props?.expirationDate)}</Typography>
                    </Box>
                    <Box width={headers.find((h) => h.id === "clientName")}>
                        <Typography variant="body2">{props?.clientName}</Typography>
                    </Box>
                    <Box width={headers.find((h) => h.id === "dateUploaded")} >
                        <Typography variant="body2"> {GetfVDateFormate(props?.dateUploaded)}</Typography>
                    </Box>
                </Box>

            </ThemeProvider>
        </>
    );
}

